export default __webpack_public_path__ + "9f168fc39a683aa27b8bb754a6b69dac.svg";